export type Currency = 'EUR' | 'CHF';
export type Locale = 'de-DE' | 'en-US';

export const getPriceWithCurrency = (
  price?: number | null,
  currency?: Currency,
  locale?: Locale,
  options?: Omit<Intl.NumberFormatOptions, 'style' | 'currency'>
) => {
  if (!price || !currency) return '';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    ...options,
  }).format(price);
};
